export enum Brand {
  Yandex = 'yandex',
  Yango = 'yango',
}

export type MapLanguage = 'ru_RU' | 'ru_UA' | 'uk_UA' | 'tr_TR' | 'en_RU' | 'en_US' | 'he_IL' | 'en_IL'

export type AppConfig = {
  basename?: string
  i18n: Record<string, unknown>
  mapLang: MapLanguage
  lang: string
  dir: 'rtl' | 'ltr'
  version: string
  brand: Brand
  token?: string
  vendor?: string
  isGroceryOrder?: boolean
  yaAuthProxy: {
    host: string
    applicationDetectionRules: Record<string, string>
  }
  groceryAuthProxy: {
    host: string
  }
  supportBotID: string
  messengerServiceID: number
  yaMetrikaID?: number
  country?: string
  env: string
  sourceService?: string
}

export const __NAME__ = '__APP_CONFIG__'
